import { Utilities } from "@learningblocks/exp-constants";
const { checkIfSelectionValid } = Utilities;

//set selected option
export function selectOption(state, payload) {
  return {
    ...state,
    currentChapter: updateSelectedOptionInCurrentChapter(
      state.currentChapter,
      payload
    ),
  };
}

function updateSelectedOptionInCurrentChapter(currentChapter, payload) {
  return {
    ...currentChapter,
    components: updateSelectedOptionInComponents(
      currentChapter.components,
      payload
    ),
  };
}

function updateSelectedOptionInComponents(components, payload) {
  const updateComponent = (component) => {
    if (component.id === payload.componentID && component.options) {
      return updateOptionsInComponent(component, payload);
    } else if (component.id === payload.componentID && component.typedOptions) {
      return updateTypedOptionsInComponent(component, payload);
    } else {
      return component;
    }
  };
  return components.map(updateComponent);
}

//CSCQComponent is a component in currentSection.components
function updateOptionsInComponent(CSCQComponent, payload) {
  if (checkIfSelectionValid(CSCQComponent)) {
    CSCQComponent = {
      ...CSCQComponent,
      options: CSCQComponent.options.map((option) =>
        updateOption(option, payload)
      ),
    };
  }
  return CSCQComponent;
}

function updateTypedOptionsInComponent(CSCQComponent, payload) {
  if (checkIfSelectionValid(CSCQComponent)) {
    CSCQComponent = {
      ...CSCQComponent,
      typedOptions: CSCQComponent.typedOptions.map((option) =>
        updateOption(option, payload)
      ),
    };
  }
  return CSCQComponent;
}

function updateOption(option, payload) {
  if (option.disabled === false) {
    if (payload.optionID === option.id) {
      option = { ...option, selected: true };
    } else {
      option = { ...option, selected: false };
    }
  }
  return option;
}
